export const tierPricing = [
  {
    maxSeats: 3,
    label: "Up to 3 seats",
    priceId: process.env.STRIPE_PRICE_3_SEATS,
    amount: 5000,
  },
  {
    maxSeats: 8,
    label: "Up to 8 seats",
    priceId: process.env.STRIPE_PRICE_8_SEATS,
    amount: 10000,
  },
  {
    maxSeats: 15,
    label: "Up to 15 seats",
    priceId: process.env.STRIPE_PRICE_15_SEATS,
    amount: 15000,
  },
  {
    maxSeats: 25,
    label: "Up to 25 seats",
    priceId: process.env.STRIPE_PRICE_25_SEATS,
    amount: 22500,
  },
];

export function getTierForSeats(seatCount) {
  const tier = tierPricing.find((tier) => seatCount <= tier.maxSeats);
  if (!tier) throw new Error("No tier available for that seat count");
  return tier;
};
